import dayjs from 'dayjs';
import { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from 'material-react-table';

export interface TableCriteria {
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
  pagination: MRT_PaginationState;
}



export function tableParams(criteria: TableCriteria, dateFields = new Set<string>(), aliases: Record<string, string> = {}): URLSearchParams {
  const params = new URLSearchParams({
    limit: String(criteria.pagination.pageSize),
    offset: String(criteria.pagination.pageIndex * criteria.pagination.pageSize),
  });

  const search = criteria.globalFilter.trim();
  if (search) params.set('search', search);
  const sort = criteria.sorting[0];
  if (sort) params.set('ordering', `${sort.desc ? '-' : ''}${sort.id}`);

  criteria.columnFilters.forEach(({ id, value }) => {
    if (dateFields.has(id)) {
      const [from, to] = Array.isArray(value) ? value : [value, value];
      if (dayjs.isDayjs(from) && from.isValid()) {
        params.set(`${id}_from_date`, from.format('YYYY-MM-DD'));
      }
      if (dayjs.isDayjs(to) && to.isValid()) {
        params.set(`${id}_to_date`, to.format('YYYY-MM-DD'));
      }
    } else if (value !== null && value !== undefined && value !== '') {
      params.set(aliases[id] ?? id, String(value));
    }
  });
  if (Array.from(dateFields).some(field =>
    params.has(`${field}_from_date`) || params.has(`${field}_to_date`)
  )) {
    params.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC');
  }
  return params;
}

